import React, { useState, useEffect, forwardRef } from 'react';
import styled from 'styled-components';

const InputControl = styled.textarea`
    width: 100%;
    border: 2px solid #C8CFD2;
    border-radius: 4px;
    box-sizing: border-box;
    outline: none;
    padding: 8px;
    font-size: 14px;
    line-height: 24px;
    resize: ${p => p.noResize ? 'none' : 'vertical'};
    ${p => p.height ? `height: ${p.height}px;` : ''}
    &::placeholder{
        color: ${p => p.isDarkMode ? "rgba(255,255 , 255, 0.5)" : "rgba(0, 0, 0, 0.15)"};
        font-style: italic;
    }
    &:focus {
        border: 2px solid #73AFC0;
        box-shadow: 0 0 0 4px "#E3ECEF";
    }
    @media (max-width: 480px) {
        // leave room for reply button
        padding-right: 40px;
    }
`;

interface MultilineInputProps {
    value: string;
    changeAction?: (e) => void;
    onKeyPress?: (e) => void;
    noResize?: boolean;
    rows?: number;
    placeHolder?: string;
    height?: number;
}

const MultilineInputComponent = forwardRef(function ({ value, changeAction, onKeyPress, noResize, rows, placeHolder, height }: MultilineInputProps, ref) {
    const [currentRows, setCurrentRows] = useState(rows ?? 1);

    useEffect(() => {
        const lineCount = (value.match(/\n/g)?.length ?? 0) + 1;
        const minRows = rows ?? 1;
        if (noResize && lineCount >= minRows && lineCount < 20) {
            setCurrentRows(lineCount);
        }
    }, [value, rows, noResize]);

    return (<InputControl
        value={value}
        onChange={changeAction}
        onKeyUp={onKeyPress}
        noResize={noResize}
        rows={currentRows}
        placeholder={placeHolder}
        height={height}
        ref={ref}
    />);
});

MultilineInputComponent.displayName = "MultilineInputComponent";

export default MultilineInputComponent;